<div class="permission-scope">
  <div
    class="permission-scope__bars"
    [attr.aria-label]="'SETTINGS_ACCESS.ROLES.PERMISSION_SCOPE' | translate">
    @for (summary of summaries(); track summary.group.id) {
      <tf-settings-role-grants-popover
        [title]="summary.group.titleKey | translate"
        [level]="summary.level"
        [grants]="summary.grants">
        <button
          type="button"
          [class]="permissionBarClass(summary.level)"
          [attr.aria-label]="
            (summary.group.titleKey | translate) + ': ' + levelLabel(summary.level)
          ">
          <span class="sr-only">
            {{ summary.group.titleKey | translate }}: {{ levelLabel(summary.level) }}
          </span>
        </button>
      </tf-settings-role-grants-popover>
    }
  </div>
  <span class="permission-scope__count">
    {{
      'SETTINGS_ACCESS.ROLES.GRANT_GROUP_COUNT'
        | translate: { grants: grantCount(), groups: groupCount() }
    }}
  </span>
</div>
